<script setup lang="ts">
import {computed, provide, ref} from 'vue'
import DocumentsIndex from '@/components/UI/Documents/Index.vue'
import {uploadJobFiles, jobFilesIndex, jobFileDestroy, jobFileUpdate, jobFileShow} from '@/api/jobs'
import {useRoute} from 'vue-router'
import { useAuth } from '@/utils/auth'

const route = useRoute()
const auth = useAuth()
const jobId = computed(() => {
  return route.params.id
})

const canUpload = computed(() => auth.check('create job documents'))
const canEdit = computed(() => auth.check('edit job documents'))
const canDelete = computed(() => auth.check('delete job documents'))

provide('apiId', jobId)
provide('apiIdField', 'job_id')

const api  = ref({
  upload: uploadJobFiles,
  index: jobFilesIndex,
  delete: jobFileDestroy,
  update: jobFileUpdate,
  show: jobFileShow
})

// Pass the API to the gallery
provide('api', api)

</script>

<template>
  <div>
    <DocumentsIndex :can-upload="canUpload" :can-edit="canEdit" :can-delete="canDelete" />
  </div>
</template>

<style scoped lang="scss">

</style>
